import { computed } from 'vue';
import useAcvStore from '@/composables/useAcvStore';
import useAcvFeatureFlags from '@/composables/useAcvFeatureFlags';
import router from '@/router';

const useAcvAnnouncements = () => {
  const store = useAcvStore();
  const acvFeatureFlags = useAcvFeatureFlags();

  const canShowEulaReviewBanner = (configuredLanes) => {
    const isLaneEulaAcceptanceRequired = acvFeatureFlags.getFlag(
      'requireEulaAcceptanceForLanes',
    );

    if (!isLaneEulaAcceptanceRequired.value) {
      return false;
    }

    const eulaReviewBannerVisible = computed(
      () => store.getters['marketplaceView/eulaReviewBannerVisible'],
    );

    const notAcceptedLanes = configuredLanes.filter(
      (lane) => lane.eulaAccepted === false,
    );

    return (
      ['Marketplace', 'Search'].includes(router.currentRoute?.name)
      && notAcceptedLanes.length > 0
      && eulaReviewBannerVisible.value
    );
  };

  const updateAnnouncement = (announcement) => {
    store.dispatch('announcements/updateAnnouncement', announcement);
  };

  const removeAnnouncementByKey = (key) => {
    store.dispatch('announcements/removeAnnouncementByKey', key);
  };

  const resetAnnouncements = () => {
    store.dispatch('announcements/resetAnnouncements');
  };

  return {
    canShowEulaReviewBanner,
    updateAnnouncement,
    removeAnnouncementByKey,
    resetAnnouncements,
  };
};
export default useAcvAnnouncements;
